import { Dropdown, TextField } from '@symphony-ui/uitoolkit-components';
import Value from '../../../../../../models/data/Value';
import * as React from 'react';
import PopupContext from 'contexts/PopupContext';
const ValueBaseEditor = ({ label = "Value", value, onChange }) => {
    const { setBlockClose } = React.useContext(PopupContext);
    const [prefix, setPrefix] = React.useState(value?.prefix);
    const [val, setVal] = React.useState(value?.value?.toString() ?? '');
    const options = React.useMemo(() => ([
        { label: 'High', value: 'HIGH' },
        { label: 'Mid/High', value: 'MID_HIGH' },
        { label: 'Mid', value: 'MID' },
        { label: 'Low/Mid', value: 'LOW_MID' },
        { label: 'Low', value: 'LOW' }
    ]), []);
    const onChangeVal = React.useCallback((event) => {
        const newText = event.target.value;
        setVal(newText);
        if (!Number.isNaN(newText)) {
            const newValue = Number.parseFloat(newText);
            const updated = value !== undefined ? value.updateValue(newValue) : new Value({ value: newValue });
            onChange({ target: { value: updated } });
        }
    }, [onChange, value]);
    const onChangePrefix = React.useCallback((event) => {
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        const newValue = event.target.value !== null ? event.target.value.value : undefined;
        setPrefix(newValue);
        if (value !== undefined) {
            const updated = value.updatePrefix(newValue);
            onChange({ target: { value: updated } });
        }
    }, [onChange, value]);
    const onMenuClose = React.useCallback(() => {
        setBlockClose(false);
    }, [setBlockClose]);
    const onMenuOpen = React.useCallback(() => {
        setBlockClose(true);
    }, [setBlockClose]);
    return (React.createElement("div", { style: { display: 'flex', width: '12rem', marginRight: '0.5rem' } },
        React.createElement("div", { className: 'select-addon', style: { alignSelf: 'end', width: '8rem' } },
            React.createElement(Dropdown, { isInputClearable: true, label: label, onChange: onChangePrefix, onMenuOpen: onMenuOpen, onMenuClose: onMenuClose, options: options, value: options.find(o => o.value === prefix) })),
        React.createElement("div", { style: { alignSelf: 'end', width: '4rem' } },
            React.createElement(TextField, { value: val, onChange: onChangeVal }))));
};
export default ValueBaseEditor;
